import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserProfileComponent } from '../user-profile.component';

@Component({
  selector: 'app-pending-account-deletion',
  templateUrl: './pending-account-deletion.component.html',
  styleUrls: ['./pending-account-deletion.component.scss'],
})
export class PendingAccountDeletionComponent {
  @Input() autoDeactivationDate!: string;
  @Input() userName!: string;
  @Input() stepper!: number;
  @Output() stepperChange = new EventEmitter<number>();
  @Output() removeUserAction = new EventEmitter<void>();
  @Output() rejectDeletionAction = new EventEmitter<void>();

  constructor(public dialogRef: MatDialogRef<UserProfileComponent>) {}

  get formattedDate(): string {
    if (!this.autoDeactivationDate) return '';
    const date = new Date(this.autoDeactivationDate.replace(/\//g, '-'));
    return date.toLocaleDateString('en-US', { month: 'long', day: 'numeric' });
  }

  goBack(): void {
    this.stepperChange.emit(1);
  }

  closeDialog(): void {
    this.dialogRef?.close();
  }

  onRemoveUser(): void {
    this.removeUserAction.emit();
  }

  onRejectDeletion(): void {
    this.rejectDeletionAction.emit();
  }
}
